module.exports = __webpack_public_path__ + "static/media/tutorial-start-step4.c5b7a46e.png";